import { render, staticRenderFns } from "./ProfilePhotoStickerComponent.vue?vue&type=template&id=411dcb56&scoped=true&lang=pug&"
import script from "./ProfilePhotoStickerComponent.vue?vue&type=script&lang=js&"
export * from "./ProfilePhotoStickerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePhotoStickerComponent.vue?vue&type=style&index=0&id=411dcb56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411dcb56",
  null
  
)

export default component.exports